import { defaultDateDef, defaultNumberDef } from '@components/_SiteWide/CellTemplates/typeColumnDefs'
import moment from 'moment'

export const getColumnDefs = ({ cancelLoadingState, onRunCancel }) => [
  {
    field: 'status',
    headerName: 'Status',
    cellRenderer: 'SupplyHistoryStatus',
    flex: 3,
  },
  {
    field: 'started',
    headerName: 'Time Ran / Scheduled',
    flex: 3,
    ...defaultDateDef('started'),
  },
  {
    field: 'order_numbers',
    headerName: 'No. Of Orders',
    ...defaultNumberDef('order_numbers', 0),
    valueGetter: ({ data }) => data.order_numbers?.length,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: 'SupplyHistoryActions',
    cellRendererParams: { cancelLoadingState, onRunCancel },
    editable: false,
    filter: false,
  },
]
